import { createFileRoute, useSearch } from "@tanstack/react-router";
import { KBLayout } from "@client/components/kb/kb-layout";

export interface KbSearch {
  space?: "private" | "public";
  kbId?: string;
  packId?: string;
  topicId?: string;
}

function isValidSpace(value: unknown): value is "private" | "public" {
  return value === "private" || value === "public";
}

export const Route = createFileRoute("/_app/kb")({
  validateSearch: (search: Record<string, unknown>): KbSearch => ({
    space: isValidSpace(search.space) ? search.space : undefined,
    kbId: typeof search.kbId === "string" ? search.kbId : undefined,
    packId: typeof search.packId === "string" ? search.packId : undefined,
    topicId: typeof search.topicId === "string" ? search.topicId : undefined,
  }),
  component: KBLayout,
});

export function useKbSearch() {
  return useSearch({ from: "/_app/kb" });
}
